import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { IndexCard, Kontor } from '@store/models';

@Injectable({providedIn: 'root'})
export class AdminService {

    constructor(
        private http: HttpClient
    ) {}

    getOffices(): Observable<Kontor[]> {
        const url = `[api]/Admin/offices`;
        return this.http.get<Kontor[]>(url);
    }

    getUsers(officeId: number): Observable<IndexCard[]> {
        const url = `[api]/model/Indexcard/ByOffice/${officeId}`;
        return this.http.get<IndexCard[]>(url);
    }

}
